module.exports = __webpack_public_path__ + "img/unlock-menu.e5bcd28b.svg";